import { motion } from 'framer-motion';
import styled from 'styled-components';

import Background from 'assets/images/landing/background.png';
import { setTypography, setVh } from 'utils/styles/mixins';
import { mediaMobileSmallHeight, mediaTablet } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

export const Wrapper = styled(motion.div)`
  width: 100vw;
  min-height: ${setVh(100)};
  height: 100%;
  background: ${colors.pearlBush};
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: url(${Background});
    background-size: cover;
    background-repeat: no-repeat;
    user-select: none;
    z-index: 0;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 3;
  justify-content: center;
  align-items: center;
`;

export const IconWrapper = styled.div`
  width: 120rem;
  height: 120rem;

  ${mediaTablet`
    width: 160rem;
    width: 160rem;
  `}

  ${mediaMobileSmallHeight(`
    width: 160rem;
    width: 160rem;
  `)}
`;

export const Icon = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

export const Title = styled(motion.div)<{ isWindowTooSmall?: boolean }>`
  color: ${colors.spicyMix};
  ${({ theme: { locale } }) => setTypography('heading2', locale)};
  white-space: pre-wrap;
  margin-top: 40rem;
  text-align: ${({ isWindowTooSmall }) =>
    isWindowTooSmall ? 'left' : 'center'};

  font-size: 80rem;

  h1 {
    user-select: none;
  }

  ${mediaTablet`
    margin-top: 80rem;
  `}
`;

export const LogoWrapper = styled(motion.div)`
  position: absolute;
  top: 64rem;
  left: 0;
  user-select: none;
  z-index: 2;

  svg {
    width: 250rem;
  }

  ${mediaTablet`
    svg {
      width: 488rem;
    }
  `}

  ${mediaMobileSmallHeight(`
    svg {
      width: 445rem;
    }
  `)}
`;
